import { createTheme } from "@material-ui/core";

const dark = createTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#018ebc",
      dark: "#006383",
      light: "#33a4c9",
    },
    secondary: {
      main: "#ff1744",
      dark: "#b2102f",
      light: "#ff4569",
    },
    background: {
      default: "#232b36",
      paper: "#323e4e",
    },
  },
});

export default dark;
